import { observable, set, computed } from 'mobx';

class Offer {
  @observable offerCode: string;

  @observable confirmMsg: string;

  @observable activation: string;

  @observable allowMsg: number;

  static fromJSON(data: Offer): Offer {
    const offer = new Offer();
    set(offer, data);

    return offer;
  }

  @computed
  get isAllowed(): boolean {
    return this.activation === 'manual' || (this.activation === 'automatic' && this.allowMsg === 1);
  }
}

export default Offer;
